/* eslint-disable no-unused-vars, max-len */
/* eslint-disable prefer-destructuring */
/* eslint-disable indent */
/* eslint-disable react/jsx-no-comment-textnodes */
import moment from 'moment'
import React, { useEffect, useState, useMemo, useRef } from 'react'
import ReactImageGallery from 'react-image-gallery'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { Spinner } from 'reactstrap'
import orderApi from '_api/order'
import { FaTruck } from 'react-icons/fa'
import {
  getPurchaseDetail,
  cancelOrder,
  updateDataPurchaseDetail,
  updateCommentPurchaseDetail,
  updateMyOrder,
  getMyOrders,
  getListPurchaseDetail,
  updateMyOrderWithDelivery,
} from '_redux/modules/order'
import {
  clearDeliveryDetail,
  getDeliveryByBuyer,
  clearDeliveryByBuyer,
  clearListDeliveryAndDeliveryBooking,
} from '_redux/modules/delivery'
import useQuery from '_hooks/useQuery'
import useHitpayPolling from '_hooks/useHitpayPolling'

import {
  updateTotalOrderCountWhenCancelOrder,
  clearEventAndOrder,
  getListCombinedPayment,
} from '_redux/modules/event'
import { updateTotalOrderCountInGroupWhenOrderWhenCancelOrder } from '_redux/modules/group'

import {
  BUYER_CANCELED,
  BUYER_COLLECTED,
  BUYER_PAID,
  BUYER_UNPAID,
  EVENT_CLOSE,
  GMT_0,
  HOST_ORDER_CANCELED,
  HOST_ORDER_UNPAID,
  HOST_ORDER_VERIFIED,
  IS_PICKUP_DAY,
  LIST_TIME,
  NOT_PAYNOW,
  PAYABLE,
  PAYNOW,
  SHORT_DATE,
  DELIVERY_BUYER_PAID,
  DELIVERY_BUYER_CANCELLED,
  DELIVERY_HOST_CANCELLED,
  PAY_TOGETHER,
  HOST_ORDER_SUBMITTED_UNPAID,
  HOST_ORDER_SUBMITTED_VERIFIED,
  HOST_ORDER_SUBMITTED_COLLECTED,
  SELECTION_MODE_SINGLE,
  SELECTION_MODE_MULTIPLE,
  BUYER_REFUNDED,
  HOST_ORDER_REFUNDED,
} from '_utils/constant'
import {
  convertToCurrentGMT,
  convertTimestampToCurrentGMT,
  numDayFromNow,
  convertTimeStringWithDuration,
  handleCombinedPayment,
} from '_utils/function'
import { getUserInfo } from '_utils/localData'

import Cancel from '../components/Cancel'
import Collected from '../components/Collected'
import Submitted from '../components/Submitted'
import CollectionConfirm from '../components/CollectionConfirm'
import RefundConfirm from '../components/RefundConfirm'
import Refunded from '../components/Refunded'
import MyGallery from '../components/gallery'
import HeaderEventInfo from '../components/HeaderEventInfo'
import OrderConfirmed from '../components/OrderConfirmed'
import OrderConfirmedAfterClose from '../components/OrderConfirmedAfterClose'
import Payment from '../components/Payment'
import PendingConfirm from '../components/PendingConfirm'
import AmendDeliveryAddressModal from './components/AmendDeliveryAddressModal'
import './style.scss'

const ProductOrderDetail = ({ productOrder, event, handleUpdateNote, orderRef, comment, bookingAddress, deliveryDate, onBookingAddressChange, consignee }) => {
  const formattedDeliveryDate = deliveryDate
    ? (moment(deliveryDate, 'DD-MM-YYYY', true).isValid()
        ? moment(deliveryDate, 'DD-MM-YYYY').format('D MMM YYYY')
        : moment(new Date(deliveryDate)).isValid()
          ? moment(new Date(deliveryDate)).format('D MMM YYYY')
          : deliveryDate)
    : ''
  return (
    <div className='detail-list-news__item' style={{ borderBottom: 'none', fontSize: '0.6875rem' }}>
    <table id='itemList' style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        {productOrder &&
        productOrder.allProductPerOrder &&
        productOrder.allProductPerOrder.length > 0
          ? productOrder.allProductPerOrder.map((item, index) => {
              const isSingleTrackInventory =
                item.pSubItemSelectionMode === SELECTION_MODE_SINGLE &&
                Boolean(item.pSubItemTrackInventory)

              const isMultiple =
                item.pSubItemSelectionMode === SELECTION_MODE_MULTIPLE ||
                item.pSubItemSelectionMode === 'multiple'

              const basePrice =
                item.pPriceNoSubItems !== undefined && item.pPriceNoSubItems !== null
                  ? Number(item.pPriceNoSubItems)
                  : Number(item.pPrice || 0)

              const itemTotal = Number(item.pPrice || 0) * Number(item.pQuantity || 1)
              const hasSubItems = item.pSubItems && item.pSubItems.length > 0

              return (
                <tr
                  key={index}
                  style={{
                    borderBottom:
                      index < productOrder.allProductPerOrder.length - 1
                        ? '1px solid #f1f5f9'
                        : 'none',
                  }}
                >
                  <td
                    className='product-item-gallery-col'
                    style={{ width: '100px', verticalAlign: 'top', padding: '12px 10px 12px 0' }}
                  >
                    <MyGallery image={item.pPhotoUrls} />
                  </td>

                  <td style={{ verticalAlign: 'top', padding: '12px 8px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div
                        style={{
                          minHeight: '22px',
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                        }}
                      >
                        <span style={{ fontWeight: 600, color: 'rgb(147, 144, 145)', fontSize: '14px' }}>
                          {item.pName}
                        </span>
                        {item.pPurchaseType ? (
                          <span style={{ color: '#939091', fontSize: '11px', marginLeft: '6px' }}>
                            {item.pPurchaseType === 'case' ? '' : '(individual)'}
                          </span>
                        ) : null}
                      </div>

                      {hasSubItems &&
                        item.pSubItems.map((item1, idx) => {
                          if (isMultiple) {
                            const priceStr = Number(item1.price || 0).toFixed(2)
                            const qtyStr = item1.qty || 1
                            return (
                              <div
                                key={idx}
                                style={{
                                  minHeight: '38px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  paddingLeft: '2px',
                                }}
                              >
                                <div style={{ color: '#64748b', fontSize: '13px', lineHeight: '18px' }}>
                                  - {item1.name}
                                </div>
                                <div style={{ color: '#94a3b8', fontSize: '12px', lineHeight: '18px', paddingLeft: '8px' }}>
                                  (+ ${priceStr} x{qtyStr})
                                </div>
                              </div>
                            )
                          }

                          // Single selection
                          return (
                            <div
                              key={idx}
                              style={{
                                minHeight: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                color: '#64748b',
                                fontSize: '13px',
                                paddingLeft: '2px',
                              }}
                            >
                              - {item1.name}
                            </div>
                          )
                        })}
                    </div>
                  </td>

                  {/* Qty */}
                  <td
                    className='text-right product-item-qty-col'
                    style={{
                      verticalAlign: 'top',
                      padding: '12px 8px',
                      whiteSpace: 'nowrap',
                      width: '65px',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div
                        className='product-item-qty'
                        style={{
                          minHeight: '22px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          color: '#334155',
                          fontSize: '13px',
                        }}
                      >
                        QTY: {item.pQuantity}
                      </div>
                      {hasSubItems &&
                        item.pSubItems.map((_, idx) => (
                          <div key={idx} style={{ minHeight: isMultiple ? '38px' : '20px' }} />
                        ))}
                    </div>
                  </td>

                  {/* Price & add-ons */}
                  <td
                    className='text-right'
                    style={{
                      verticalAlign: 'top',
                      padding: '12px 8px',
                      whiteSpace: 'nowrap',
                      width: '90px',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div
                        style={{
                          minHeight: '22px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          color: '#334155',
                          fontSize: '13px',
                        }}
                      >
                        {!isSingleTrackInventory ? `$${basePrice.toFixed(2)}` : ''}
                      </div>

                      {hasSubItems &&
                        item.pSubItems.map((item1, idx) => {
                          let priceText = ''
                          if (isSingleTrackInventory) {
                            const singlePrice = basePrice + Number(item1.price || 0)
                            priceText = `$${singlePrice.toFixed(2)} x${item1.qty || 1}`
                          } else if (isMultiple) {
                            const subTotal =
                              Number(item1.price || 0) * Number(item1.qty || 1)
                            priceText = `+$${subTotal.toFixed(2)}`
                          } else {
                            const subPrice = Number(item1.price || 0)
                            priceText = `+$${subPrice.toFixed(2)}`
                          }

                          return (
                            <div
                              key={idx}
                              style={{
                                minHeight: isMultiple ? '38px' : '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                color: '#64748b',
                                fontSize: '13px',
                              }}
                            >
                              {priceText}
                            </div>
                          )
                        })}
                    </div>
                  </td>
                </tr>
              )
            })
          : null}
      </tbody>
    </table>
    <br />
    <table style={{ color: '#939091' }}>
      <tbody>
        <tr>
          <td colSpan={2} className='text-right'>
            <span>Total: </span>
          </td>
          <td className='text-right' style={{ width: '20%' }}>
            ${Number(productOrder?.totalPricePerOrder).toFixed(2)}
          </td>
        </tr>
        {Number(productOrder?.discountPerOrder) > 0 && (
          <tr>
            <td colSpan={2} className='text-right'>
              <span>Discount: </span>
            </td>
            <td className='text-right' style={{ width: '20%' }}>
              <span id='sharedDiscount'>
                -$
                {event?.status === EVENT_CLOSE ||
                (event?.status !== EVENT_CLOSE &&
                  numDayFromNow(convertToCurrentGMT(event?.closingTime)) < 1)
                  ? Number(productOrder?.discountPerOrder).toFixed(2)
                  : `${Number(productOrder?.discountPerOrder).toFixed(2)}`}
              </span>
            </td>
          </tr>
        )}
        {Number(productOrder?.deliveryPerOrder) > 0 && (
          <tr>
            <td colSpan={2} className='text-right'>
              <span>Delivery: </span>
            </td>
            <td className='text-right'>
              <span id='sharedDeliveryCost'>
                $
                {event?.status === EVENT_CLOSE ||
                (event?.status !== EVENT_CLOSE &&
                  numDayFromNow(convertToCurrentGMT(event?.closingTime)) < 1)
                  ? Number(productOrder?.deliveryPerOrder).toFixed(2)
                  : `${Number(productOrder?.deliveryPerOrder).toFixed(2)}`}
              </span>
            </td>
          </tr>
        )}
        {Number(productOrder?.adminCostPerOrder) > 0 && (
          <tr>
            <td colSpan={2} className='text-right'>
              <span>Admin fee: </span>
            </td>
            <td className='text-right'>
              <span id='sharedAdminCost'>${Number(productOrder?.adminCostPerOrder).toFixed(2)}</span>
            </td>
          </tr>
        )}
        <tr className='c-ttl-blue'>
          <td colSpan={2} className='text-right'>
            <span>
              <strong>Final: </strong>
            </span>
          </td>
          <td className='text-right'>
            <strong>${Number(productOrder?.totalFee).toFixed(2)}</strong>
          </td>
        </tr>
      </tbody>
    </table>
    <div className='c-form'>
      {event.bookingAddressRequired && bookingAddress ? (
        <div style={{ color: '#51aaaa' }}>
          <p className='mb-1 mt-2 d-flex align-items-start gap-2'>
            <FaTruck style={{ color: '#51aaaa', fontSize: '1rem', marginTop: '2px', flexShrink: 0 }} />
            <span style={{ color: '#51aaaa', fontSize: '16px' }}>
              <b>Delivery Date: </b>
              <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={onBookingAddressChange}
              >
                {formattedDeliveryDate}
              </span>
            </span>
          </p>
          <p className='ml-4 mt-1 mb-0'>
            <span style={{ color: '#51aaaa', fontSize: '16px' }}>
              <b>Address:</b> <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={onBookingAddressChange}
              >
                {bookingAddress}
              </span>
            </span>
          </p>
          {consignee ? (
            <p className='ml-4 mt-1'>
              <span style={{ color: '#51aaaa', fontSize: '16px' }}>
                <b>Consignee Name:</b>{' '}
                <span
                  style={{
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  }}
                  onClick={onBookingAddressChange}
                >
                  {consignee}
                </span>
              </span>
            </p>
          ) : null}
        </div>
      ) : null}
      <label className='c-ttl-blue c-txt-9'>NOTES TO THE HOST</label>
      <textarea
        rows={3}
        className='form-control'
        onBlur={(e) => handleUpdateNote(e, orderRef)}
        defaultValue={comment}
      />
    </div>
  </div>
  )
}

const BoxOrder = ({
  order,
  listCheckedOrder,
  handleCheckOrder,
  showDetailProduct,
  hideDetailProduct,
  orderDetail,
  listShowDetail,
  handleUpdateNote,
  showConsolidatedBill,
}) => (
  <div className='box-order-with-delivery'>
    <div className='d-flex justify-content-between align-items-center' style={{ padding: '0px 10px 0px 0px' }}>
      <div className='custom-control custom-checkbox box-same-delivery-current-order__item-order checkbox-order-item'>
        <input
          id={order?.ref}
          type='checkbox'
          onChange={(e) => handleCheckOrder(e, order?.ref)}
          checked={listCheckedOrder.includes(order?.ref)}
        />
        <label className='custom-control-label checkbox-order-item__label' htmlFor={order?.ref}>
          {order.eTitle}
        </label>
      </div>
      {orderDetail?.find((e) => e.ref === order?.ref) && listShowDetail.includes(order?.ref) ? (
        <i
          onClick={() => hideDetailProduct(order?.ref)}
          style={{ cursor: 'pointer', color: '#15cdca' }}
          className='arrow_carrot-up d-flex align-items-center'
        ></i>
      ) : null}
      {orderDetail?.find((e) => e.ref === order?.ref) && !listShowDetail.includes(order?.ref) ? (
        <i
          onClick={() => showDetailProduct(order?.ref)}
          style={{
            cursor: 'pointer',
            color: '#15cdca',
          }}
          className='arrow_carrot-down d-flex align-items-center'
        ></i>
      ) : null}
    </div>
    {listShowDetail &&
    listShowDetail.includes(order?.ref) &&
    orderDetail?.find((e) => e.ref === order?.ref) ? (
      <ProductOrderDetail
        productOrder={orderDetail?.find((e) => e.ref === order?.ref)?.productOrder}
        event={orderDetail?.find((p) => p.ref === order?.ref)?.event}
        orderRef={order?.ref}
        eid={order?.eid}
        comment={orderDetail?.find((p) => p.ref === order?.ref)?.comment}
        handleUpdateNote={handleUpdateNote}
        deliveryIncludedCurrOrder={order?.deliveryBooking}
        showConsolidatedBill={showConsolidatedBill}
        bookingAddress={orderDetail?.find((item) => item.ref === order?.ref)?.bookingAddress}
        deliveryDate={orderDetail?.find((item) => item.ref === order?.ref)?.deliveryDate}
      />
    ) : null}
  </div>
)

const BoxDelivery = ({ delivery, listCheckedDelivery, handleCheckDelivery }) => (
  <div className='box-order-with-delivery'>
    <div className='custom-control custom-checkbox box-order-with-delivery__item-order checkbox-order-item'>
      <input
        id={delivery?.ref}
        type='checkbox'
        onChange={(e) => handleCheckDelivery(e, delivery?.ref)}
        checked={listCheckedDelivery.includes(delivery?.ref)}
      />
      <label className='custom-control-label checkbox-order-item__label' htmlFor={delivery?.ref}>
        {`Delivery for (${convertTimeStringWithDuration(
          delivery.dDeliveryTime,
          delivery.dDeliveryDuration
        )}) ($${delivery.dzPrice.toFixed(2)})`}
      </label>
    </div>
  </div>
)

const PurchaseDetail = () => {
  const params = useQuery()
  const orderRef = params.get('ref')
  const history = useHistory()
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const userInfo = getUserInfo()

  const photoRef = useRef()

  const { id: buyerId } = userInfo

  const {
    orderDetail,
    myOrders = [],
    errorOrderDetail,
    listCurrentOrder = [],
  } = useSelector((state) => state.order)
  const { listDeliveryByBuyer = [] } = useSelector((state) => state.delivery)
  const { listCombinedPayments = [] } = useSelector((state) => state.event)

  const { event, productOrder, orderNo, buyerStatus, status, comment, eid, combinedPaymentRef, consignee } =
    orderDetail.find((item) => item.ref === orderRef) || {}
  const { paymentScreenshot } = productOrder || {}

  const isPaymentViaHitPay = event?.isUsingHitpay || false

  const listConsolidatedBillingOrder = useMemo(() => {
    if (!myOrders.length) return []

    const now = moment().unix()

    return myOrders
      .filter((item) => (
        item.eCreatedUserId === event?.createdUserId &&
        item.ePayable === PAYABLE &&
        item.ref !== orderRef &&
        item.buyerStatus !== BUYER_PAID &&
        item.buyerStatus !== BUYER_CANCELED &&
        item.status !== HOST_ORDER_CANCELED &&
        [HOST_ORDER_UNPAID, HOST_ORDER_SUBMITTED_UNPAID].includes(item.status) &&
        item.ePayTogether === PAY_TOGETHER &&
        (item.payAfterClosing !== true || now >= item.eClosingTimestamp)
      ))
      .sort((a, b) => a.ePickupTimestamp - b.ePickupTimestamp)
  }, [myOrders, event])

  const listConsolidatedBillingDelivery = useMemo(() => {
    let deliveryReturn = []
    if (listDeliveryByBuyer.length) {
      const deliverySameHost = listDeliveryByBuyer.filter(
        (item) => item.dCreatedUserId === event?.createdUserId
      )
      const deliveryPaidAble = deliverySameHost.filter(
        (item) =>
          item.bookerStatus !== DELIVERY_BUYER_PAID &&
          item.bookerStatus !== DELIVERY_BUYER_CANCELLED &&
          item.status !== DELIVERY_HOST_CANCELLED
      )

      deliveryReturn = deliveryPaidAble.sort((a, b) => a.dDeliveryTimestamp - b.dDeliveryTimestamp)
    }
    return deliveryReturn
  }, [listDeliveryByBuyer, event])

  const [messageNoteUpdate, setMessageNoteUpdate] = useState('')
  const [paymentFileUrl, setPaymentFileUrl] = useState(paymentScreenshot)
  const [buyerStatusState, setBuyerStatusState] = useState('')
  const [showCancel, setShowCancel] = useState(false)
  const [showPending, setShowPending] = useState(false)
  const [showPayment, setShowPayment] = useState(false)
  const [showPaymentLater, setShowPaymentLater] = useState(false)
  const [showConfirmedPickup, setShowConfirmedPickup] = useState(false)
  const [showConfirmedCollect, setShowConfirmedCollect] = useState(false)
  const [showRefundConfirm, setShowRefundConfirm] = useState(false)
  const [showRefunded, setShowRefunded] = useState(false)
  const [showCollected, setShowCollected] = useState(false)
  const [showSubmitted, setShowSubmitted] = useState(false)
  const [submittedStatus, setSubmittedStatus] = useState('default')
  const [showConsolidatedBill, setShowConsolidatedBill] = useState(false)
  const [isSubmittedPayment, setIsSubmittedPayment] = useState(false)
  const [isSubmittedCollect, setIsSubmittedCollect] = useState(false)
  const [isSubmittedRefund, setIsSubmittedRefund] = useState(false)
  const [collectionTimeStart, setCollectionTimeStart] = useState('')
  const [collectionTimeEnd, setCollectionTimeEnd] = useState('')

  const [listCheckedOrder, setListCheckedOrder] = useState([orderRef])
  const [listCheckedDelivery, setListCheckedDelivery] = useState([])
  const [listShowDetail, setListShowDetail] = useState([])
  const [checkAll, setCheckAll] = useState(false)
  const [totalFeePay, setTotalFeePay] = useState(0)
  const [stringRefNumber, setStringRefNumber] = useState('')
  const isHitpayPolling = useHitpayPolling(buyerStatus, status, orderRef)

  const [refCombinedPayment, setRefCombinedPayment] = useState(combinedPaymentRef)
  const [paymentTogether, setPaymentTogether] = useState('')
  const [isAmendAddressModalOpen, setIsAmendAddressModalOpen] = useState(false)
  const [currentBookingAddress, setCurrentBookingAddress] = useState('')
  const [currentDeliveryDate, setCurrentDeliveryDate] = useState('')
  const [currentConsignee, setCurrentConsignee] = useState('')
  const selectedOrderRefs = useMemo(
    () => Array.from(new Set(listCheckedOrder.filter(Boolean))),
    [listCheckedOrder]
  )
  const missingSelectedOrderRefs = useMemo(
    () =>
      selectedOrderRefs.filter(
        (ref) => ref !== orderRef && orderDetail.findIndex((item) => item.ref === ref) === -1
      ),
    [selectedOrderRefs, orderDetail, orderRef]
  )

  useEffect(() => {
    const orderData = orderDetail.find((item) => item.ref === orderRef)
    if (orderData) {
      if (orderData.bookingAddress) setCurrentBookingAddress(orderData.bookingAddress)
      if (orderData.deliveryDate) setCurrentDeliveryDate(orderData.deliveryDate)
      if (orderData.consignee) setCurrentConsignee(orderData.consignee)
    }
  }, [orderDetail, orderRef])

  const handleBookingAddressChange = () => {
    setIsAmendAddressModalOpen(true)
  }

  useEffect(() => {
    setTotalFeePay(0)
    let fee = 0
    let stringRef = []
    listCheckedOrder.forEach((_ref) => {
      const order = orderDetail.find((item) => item.ref === _ref) || null
      if (order) {
        fee += order?.productOrder?.totalFee
        stringRef = [...stringRef, `${order?.ref?.substring(0, 4)}-no${order?.orderNo}`]
      }
    })
    listCheckedDelivery.forEach((_ref) => {
      const delivery = listConsolidatedBillingDelivery.find((item) => item.ref === _ref) || null
      if (delivery) {
        fee += delivery?.dzPrice
        stringRef = [...stringRef, `${delivery?.ref?.substring(0, 4)}`]
      }
    })
    setTotalFeePay(fee)
    setStringRefNumber(stringRef.join(', '))
  }, [listCheckedOrder, listCheckedDelivery, orderDetail])

  const listImages =
    event?.photoUrls?.map((item) => ({
      original: item,
    })) || []

  const handleCancel = async (e) => {
    e.preventDefault()
    try {
      const r = confirm('Are you sure?')
      if (r === true) {
        await orderApi.updateOrderBuyerStatus(orderRef, { buyerStatus: BUYER_CANCELED })
        dispatch(cancelOrder(orderRef))
        dispatch(
          updateTotalOrderCountWhenCancelOrder(orderDetail.find((item) => item.ref === orderRef))
        )
        dispatch(
          updateTotalOrderCountInGroupWhenOrderWhenCancelOrder(
            orderDetail.find((item) => item.ref === orderRef)
          )
        )
        history.push('/event/list-my-purchases')
      }
    } catch (error) {
      addToast(error.msgResp, { appearance: 'error', autoDismiss: true })
    }
  }
  const handleBookingAddressUpdated = (newAddress, newDeliveryDate, newConsignee) => {
    if (newAddress) setCurrentBookingAddress(newAddress)
    if (newDeliveryDate) setCurrentDeliveryDate(newDeliveryDate)
    if (newConsignee) setCurrentConsignee(newConsignee)
    // refresh from server
    dispatch(getPurchaseDetail(orderRef))
  }
  const confirmPayment = async (e) => {
    e.preventDefault()

    setIsSubmittedPayment(true)
    const photo = paymentFileUrl || photoRef.current

    if (photo) {
      try {
        if (
          (listCheckedOrder && listCheckedOrder.length > 1) ||
          (listCheckedDelivery && listCheckedDelivery.length > 0)
        ) {
          const data = {
            invoiceRefs: [...listCheckedOrder],
            deliveryBookingRefs: [...listCheckedDelivery],
            paymentScreenshot: photo,
            placerStatus: BUYER_PAID,
          }

          const { msgResp } = await orderApi.updateInvoicesPlacerStatus(data)

          dispatch(clearDeliveryDetail())
          dispatch(clearEventAndOrder())
          dispatch(clearDeliveryByBuyer())
          dispatch(clearListDeliveryAndDeliveryBooking())

          setRefCombinedPayment(msgResp.combinedPaymentRef)

          await dispatch(getListCombinedPayment([msgResp.combinedPaymentRef]))

          listCheckedOrder.forEach((item) => {
            dispatch(updateDataPurchaseDetail(item, BUYER_PAID, msgResp.combinedPaymentRef))
            dispatch(updateMyOrder(item, BUYER_PAID, msgResp.combinedPaymentRef))
          })

          listCheckedDelivery.forEach((item) => {
            dispatch(updateMyOrderWithDelivery(item, BUYER_PAID))
          })

          setIsSubmittedPayment(false)
        } else {
          await orderApi.updateOrderBuyerStatusWithPaymentScreenshot(orderRef, {
            paymentScreenshot: photo,
            buyerStatus: BUYER_PAID,
          })
          addToast('Payment submitted successfully', { appearance: 'success', autoDismiss: true })
          dispatch(updateDataPurchaseDetail(orderRef, BUYER_PAID))
          dispatch(updateMyOrder(orderRef, BUYER_PAID))
          dispatch(clearEventAndOrder())
          setBuyerStatusState(BUYER_PAID)
          setIsSubmittedPayment(false)
        }
      } catch (error) {
        setIsSubmittedPayment(false)
        addToast(error.msgResp, { appearance: 'error', autoDismiss: true })
      }
    } else {
      setIsSubmittedPayment(false)
      alert('Please upload payment screenshot')
    }
  }

  const handleUpdateNote = async (e, _orderRef) => {
    const data = e.target.value
    try {
      await orderApi.updateOrderBuyerInfo(_orderRef, { comment: data })
      dispatch(clearEventAndOrder())
      dispatch(updateCommentPurchaseDetail(_orderRef, data))
      addToast('Update Successfully', { appearance: 'success', autoDismiss: true })
    } catch (err) {
      addToast(err?.msgResp, { appearance: 'error', autoDismiss: true })
    }
  }

  const handleConfirmCollection = async (e) => {
    e.preventDefault()
    try {
      setIsSubmittedCollect(true)
      dispatch(clearEventAndOrder())
      dispatch(updateDataPurchaseDetail(orderRef, BUYER_COLLECTED))
      dispatch(updateMyOrder(orderRef, BUYER_COLLECTED))
      setBuyerStatusState(BUYER_COLLECTED)
    } catch (error) {
      setIsSubmittedCollect(false)
      addToast(error.msgResp, { appearance: 'error', autoDismiss: true })
    }
  }

  const handleBuyerConfirmRefund = async (e) => {
    e?.preventDefault?.()
    try {
      setIsSubmittedRefund(true)
      await orderApi.buyerConfirmRefund({ ref: orderRef })
      dispatch(updateDataPurchaseDetail(orderRef, BUYER_REFUNDED))
      dispatch(updateMyOrder(orderRef, BUYER_REFUNDED))
      setBuyerStatusState(BUYER_REFUNDED)
      addToast('Refund confirmed successfully', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      addToast(error?.response?.data?.message || error?.msgResp || 'Failed to confirm refund', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setIsSubmittedRefund(false)
    }
  }

  const showPaymentStatus = (_buyerStatus, _status, _event) => {
    setShowCancel(false)
    setShowPayment(false)
    setShowPaymentLater(false)
    setShowPending(false)
    setShowConfirmedCollect(false)
    setShowConfirmedPickup(false)
    setShowRefundConfirm(false)
    setShowRefunded(false)
    setShowCollected(false)
    setShowConsolidatedBill(false)
    setCheckAll(false)
    setSubmittedStatus('default')

    const hasPayAfterClosing = listCurrentOrder.some((item) => item.payAfterClosing === true)
    const now = moment().unix()
    const isCanceled = _buyerStatus === BUYER_CANCELED || _status === HOST_ORDER_CANCELED
    const isRefunded = _buyerStatus === BUYER_REFUNDED || (_status === HOST_ORDER_REFUNDED && _buyerStatus === BUYER_REFUNDED)
    const isNeedConfirmRefund = _status === HOST_ORDER_REFUNDED && _buyerStatus !== BUYER_REFUNDED
    const isUnpaid = _buyerStatus === BUYER_UNPAID && (_status === HOST_ORDER_UNPAID || _status === HOST_ORDER_SUBMITTED_UNPAID)
    const isPayNow = _event?.paynow === PAYNOW
    const isPayable = _event?.payable === PAYABLE && _event?.paynow !== PAYNOW
    const isPaidPending = _buyerStatus === BUYER_PAID && (_status === HOST_ORDER_UNPAID || _status === HOST_ORDER_SUBMITTED_UNPAID)
    const isUnpaidVerified = _buyerStatus === BUYER_UNPAID && _status === HOST_ORDER_VERIFIED
    const isPaidVerified = _buyerStatus === BUYER_PAID && _status === HOST_ORDER_VERIFIED
    const isSubmittedVerified = _status === HOST_ORDER_SUBMITTED_VERIFIED
    const isCollected = _buyerStatus > BUYER_PAID || _status > HOST_ORDER_VERIFIED
    const isSubmittedUnpaid = _status === HOST_ORDER_SUBMITTED_UNPAID && _buyerStatus === BUYER_UNPAID
    const isSubmittedCollected = _status === HOST_ORDER_SUBMITTED_COLLECTED

    if (isCanceled) {
      setShowCancel(true)
      return
    }

    if (isRefunded) {
      setShowRefunded(true)
      return
    }

    if (isNeedConfirmRefund) {
      setShowRefundConfirm(true)
      return
    }

    if (isSubmittedCollected) {
      setShowSubmitted(true)
      setSubmittedStatus('collected')
      return
    }

    if (isSubmittedUnpaid) {
      setShowSubmitted(true)
      setSubmittedStatus('unpaid')
    }

    if (isUnpaid) {
      if (isPayNow) {
        if (hasPayAfterClosing) {
          const closingDate = _event.closingTimestamp
          if (now >= closingDate) {
            setShowPayment(true)
            setShowConsolidatedBill(true)
          } else {
            setShowPaymentLater(true)
          }
        } else {
          setShowPayment(true)
          setShowConsolidatedBill(true)
        }
      } else if (isPayable) {
        setShowPayment(true)
        setShowConsolidatedBill(true)
      } else {
        setShowPaymentLater(true)
      }
      return
    }

    if (isPaidPending) {
      setShowPending(true)
      return
    }

    const isPickupDay = numDayFromNow(convertToCurrentGMT(_event?.pickupTime)) <= IS_PICKUP_DAY

    if (isUnpaidVerified || isPaidVerified || isSubmittedVerified) {
      if (isPickupDay) {
        setShowConfirmedCollect(true)
      } else {
        setShowConfirmedPickup(true)
      }
      return
    }

    if (isCollected) {
      setShowCollected(true)
    }
  }

  const [isLoading, setIsLoading] = useState(true)

  const initialOrders = async (_orderRef) => {
    setIsLoading(true)
    await dispatch(getPurchaseDetail(_orderRef))
    await dispatch(getMyOrders)
    await dispatch(getDeliveryByBuyer(buyerId))
    setIsLoading(false)
  }

  useEffect(() => {
    if (combinedPaymentRef) {
      setRefCombinedPayment(combinedPaymentRef)
      const getCombinedPayment = async () => {
        await dispatch(getListCombinedPayment([combinedPaymentRef]))
      }
      getCombinedPayment()
    }
  }, [combinedPaymentRef])

  useEffect(() => {
    if (refCombinedPayment && listCombinedPayments.length) {
      const combinedPayment =
        listCombinedPayments.find((item) => item.combinedPaymentRef === refCombinedPayment) || {}
      setPaymentTogether(handleCombinedPayment(combinedPayment, orderRef))
    }
  }, [refCombinedPayment, listCombinedPayments])

  useEffect(() => {
    if (orderRef) {
      initialOrders(orderRef) // eslint-disable-next-line no-confusing-arrow
      setListCheckedOrder((prev) =>
        prev.length === 1 && prev[0] === orderRef ? prev : [orderRef])
    }
  }, [orderRef])

  useEffect(() => {
    if (missingSelectedOrderRefs.length) {
      dispatch(getListPurchaseDetail(missingSelectedOrderRefs))
    }
  }, [dispatch, missingSelectedOrderRefs])

  useEffect(() => {
    const totalOrderSelectable = listConsolidatedBillingOrder.length + 1
    const isAllOrderChecked = selectedOrderRefs.length === totalOrderSelectable
    const isAllDeliveryChecked =
      listCheckedDelivery.length === listConsolidatedBillingDelivery.length

    setCheckAll(
      totalOrderSelectable > 0 &&
        isAllOrderChecked &&
        isAllDeliveryChecked &&
        selectedOrderRefs.includes(orderRef)
    )
  }, [
    listCheckedDelivery,
    listConsolidatedBillingDelivery,
    listConsolidatedBillingOrder,
    orderRef,
    selectedOrderRefs,
  ])

  useEffect(() => {
    if (buyerStatusState && orderRef) {
      dispatch(getPurchaseDetail(orderRef))
    }
  }, [buyerStatusState, orderRef])

  useEffect(() => {
      showPaymentStatus(buyerStatus, status, event)
  }, [buyerStatus, status, event])

  useEffect(() => {
    setPaymentFileUrl(paymentScreenshot)
  }, [paymentScreenshot])

  useEffect(() => {
    setTimeout(() => {
      setMessageNoteUpdate('')
    }, 3000)
  }, [messageNoteUpdate])

  useEffect(() => {
    if (event?.pickupTime && event?.pickupDuration) {
      const pickupTimeCurrentGMT = convertToCurrentGMT(event?.pickupTime)
      const timeStart = Number(pickupTimeCurrentGMT.split(' ')[1].split(':')[0])
      const timeEnd = timeStart + event?.pickupDuration / 3600
      if (timeEnd <= 24) {
        const indexStart = LIST_TIME.findIndex((item) => item.id === timeStart)
        const indexEnd = LIST_TIME.findIndex((item) => item.id === timeEnd % 24)
        setCollectionTimeStart(LIST_TIME[indexStart]?.text)
        setCollectionTimeEnd(LIST_TIME[indexEnd]?.text)
      } else {
        setCollectionTimeStart('')
        setCollectionTimeEnd('')
      }
    }
  }, [event?.pickupTime, event?.pickupDuration])

  const handleCheckOrder = (e, _ref) => {
    const checked = e.target.checked
    setListCheckedOrder((prev) => (
      checked
        ? Array.from(new Set([...prev, _ref]))
        : prev.filter((item) => item !== _ref)
    ))
  }

  const handleCheckDelivery = (e, _ref) => {
    const checked = e.target.checked
    setListCheckedDelivery((prev) => (
      checked
        ? Array.from(new Set([...prev, _ref]))
        : prev.filter((item) => item !== _ref)
    ))
  }

  const handleCheckAll = (e) => {
    const checked = e.target.checked
    if (checked) {
      const newListCheckOrder = [orderRef]
      const newListCheckDelivery = []
      listConsolidatedBillingOrder.forEach((item) => {
        newListCheckOrder.push(item.ref)
      })

      listConsolidatedBillingDelivery.forEach((item) => {
        newListCheckDelivery.push(item.ref)
      })

      dispatch(getListPurchaseDetail(newListCheckOrder))
      setListCheckedOrder(Array.from(new Set(newListCheckOrder)))
      setListCheckedDelivery(Array.from(new Set(newListCheckDelivery)))
    } else {
      const newListCheckedOrder = [orderRef]
      setListCheckedOrder(newListCheckedOrder)
      setListCheckedDelivery([])
    }
  }

  const showDetailProduct = (_ref) => {
    setListShowDetail((prev) => Array.from(new Set([...prev, _ref])))
  }

  const hideDetailProduct = (_ref) => {
    setListShowDetail((prev) => prev.filter((item) => item !== _ref))
  }

  const renderListBoxOrder = () => (
    <>
      {listConsolidatedBillingOrder && listConsolidatedBillingOrder.length ? (
        <div>
          {listConsolidatedBillingOrder.map((item, index) => (
            <BoxOrder
              key={index}
              order={item}
              listCheckedDelivery={listCheckedDelivery}
              listCheckedOrder={listCheckedOrder}
              handleCheckOrder={handleCheckOrder}
              handleCheckDelivery={handleCheckDelivery}
              showDetailProduct={showDetailProduct}
              hideDetailProduct={hideDetailProduct}
              orderDetail={orderDetail}
              listShowDetail={listShowDetail}
              handleUpdateNote={handleUpdateNote}
              showConsolidatedBill={showConsolidatedBill}
            />
          ))}
        </div>
      ) : null}
    </>
  )

  const renderBoxDelivery = () => (
    <>
      {listConsolidatedBillingDelivery && listConsolidatedBillingDelivery.length ? (
        <div>
          {listConsolidatedBillingDelivery.map((item, index) => (
            <BoxDelivery
              key={index}
              delivery={item}
              listCheckedDelivery={listCheckedDelivery}
              listCheckedOrder={listCheckedOrder}
              handleCheckOrder={handleCheckOrder}
              handleCheckDelivery={handleCheckDelivery}
              showDetailProduct={showDetailProduct}
              hideDetailProduct={hideDetailProduct}
              orderDetail={orderDetail}
              listShowDetail={listShowDetail}
              handleUpdateNote={handleUpdateNote}
              showConsolidatedBill={showConsolidatedBill}
            />
          ))}
        </div>
      ) : null}
    </>
  )
  return (
    <>
      <section
        id='purchase-detail-page'
        className='section-content section-content--top'
        style={{ paddingTop: '0px' }}
      >
        {isLoading ? <div>Loading...</div> : null}
        {!isLoading && errorOrderDetail ? <div>No order found</div> : null}
        {!isLoading && !errorOrderDetail ? (
          <div className='container'>
            <div className='row-top'>
              <div className='group-list group-list--event detail-event group-list--event02'>
                <div className='group-list__item'>
                  <div style={{ width: '100%', textAlign: 'center' }}>
                    <span>
                      ORDER NO: <b id='eventBOrderNo'>{orderNo}</b>
                    </span>
                  </div>
                  <HeaderEventInfo
                    createdUserPhotoUrl={event?.createdUserPhotoUrl}
                    createdUserName={event?.createdUserName}
                    eClosingTime={convertToCurrentGMT(event?.closingTime)}
                    eTotalOrderCount={event?.totalOrderCount}
                    groupName={event?.groupName}
                    collectionTimeStart={collectionTimeStart}
                    collectionTimeEnd={collectionTimeEnd}
                    ePickupTime={convertToCurrentGMT(event?.pickupTime)}
                  />
                  <div className='group-list__des'>
                    {listImages?.length > 0 && (
                      <ReactImageGallery
                        items={listImages}
                        lazyLoad
                        autoPlay
                        showPlayButton={false}
                        showNav={false}
                        showBullets={true}
                        showThumbnails={false}
                      />
                    )}
                    <h4>
                      <Link to={`/event/detail?eid=${eid}`}>
                        {event?.title}
                      </Link>
                    </h4>
                    <p className='paragraph-pre-wrap'>{event?.description}</p>
                  </div>
                  <div className='group-list__detail group-list__detail--ogr'>
                    <div className='row'>
                      <div className='col-4'>Closing: </div>
                      <div className='col-8' style={{ color: '#51aaaa' }}>
                        {moment
                          .unix(convertTimestampToCurrentGMT(event?.closingTimestamp))
                          .utcOffset(GMT_0)
                          .format(SHORT_DATE)}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-4'>Collection: </div>
                      <div className='col-8' style={{ color: '#51aaaa' }}>
                        {moment
                          .unix(convertTimestampToCurrentGMT(event?.pickupTimestamp))
                          .utcOffset(GMT_0)
                          .format(SHORT_DATE)}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-4'>Address: </div>
                      <div className='col-8 text-blue'>{event?.pickupAddress}</div>
                    </div>
                  </div>
                  {moment().isAfter(
                    moment(convertToCurrentGMT(event?.closingTime), 'DD-MM-YYYY HH:mm')
                  ) ||
                  buyerStatus !== BUYER_UNPAID ||
                  status !== HOST_ORDER_UNPAID ||
                  (event?.paynow === NOT_PAYNOW && event?.status === EVENT_CLOSE) ? null : (
                    <div className='group-buttom'>
                      <a className='group-buttom__Cancel' href='#' onClick={handleCancel}>
                        CANCEL
                      </a>
                      <Link
                        to={`/event/detail?eid=${event?.id}&&oid=${orderRef}`}
                        className='group-buttom__Edit'
                      >
                        EDIT
                      </Link>
                    </div>
                  )}
                </div>
                <div className='detail-list-news detail-list-news--org' style={{ marginTop: 10 }}>
                  <ProductOrderDetail
                    productOrder={productOrder}
                    event={event}
                    orderRef={orderRef}
                    eid={eid}
                    handleUpdateNote={handleUpdateNote}
                    comment={comment}
                    handleCheckDelivery={handleCheckDelivery}
                    listCheckedDelivery={listCheckedDelivery}
                    showConsolidatedBill={showConsolidatedBill}
                    bookingAddress={currentBookingAddress || orderDetail?.find((item) => item.ref === orderRef)?.bookingAddress}
                    onBookingAddressChange={handleBookingAddressChange}
                    deliveryDate={currentDeliveryDate || orderDetail?.find((item) => item.ref === orderRef)?.deliveryDate}
                    consignee={currentConsignee || orderDetail?.find((item) => item.ref === orderRef)?.consignee}
                  />
                </div>
              </div>
            </div>

            {!isHitpayPolling && showConsolidatedBill &&
            ((listConsolidatedBillingDelivery && !!listConsolidatedBillingDelivery.length) ||
              (listConsolidatedBillingOrder && !!listConsolidatedBillingOrder.length)) &&
            event.payTogether === PAY_TOGETHER ? (
              <>
                <div className='list-check-box-container'>
                  <div
                    className='d-flex justify-content-between'
                    style={{ fontWeight: '500', marginBottom: '1rem' }}
                  >
                    <div style={{ display: 'inline', color: '#51aaaa', fontWeight: 600 }}>
                      {' '}
                      Pay together:{' '}
                    </div>
                    <div className='custom-control custom-checkbox' style={{ display: 'inline' }}>
                      <input
                        id='CheckAll'
                        type='checkbox'
                        onChange={(e) => handleCheckAll(e)}
                        checked={checkAll}
                      />
                      <label
                        className='custom-control-label'
                        style={{ display: 'inline', fontSize: '16px' }}
                        htmlFor='CheckAll'
                      >
                        All
                      </label>
                    </div>
                  </div>

                  {renderListBoxOrder()}

                  {renderBoxDelivery()}
                </div>
              </>
            ) : null}

            {paymentTogether ? (
              <div className='list-check-box-container'>
                <div className='pay-together'>Pay together with other order: {paymentTogether}</div>
              </div>
            ) : null}

            {isHitpayPolling ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '30px 0', gap: '12px' }}>
                <Spinner style={{ color: '#15cdca', width: '3rem', height: '3rem' }} />
                <span style={{ color: '#51aaaa', fontWeight: 600, fontSize: '18px' }}>
                  Verifying payment with HitPay...
                </span>
                <span style={{ color: '#6c757d', fontSize: '14px' }}>Please wait a moment while we update your order.</span>
              </div>
            ) : null}

            {!isHitpayPolling && showPayment ? (
              <Payment
                paymentFileUrl={paymentFileUrl}
                confirmPayment={confirmPayment}
                final={totalFeePay}
                phone={`${event?.createdUserPhone}`}
                hostId={event?.createdUserId}
                pickupTime={convertToCurrentGMT(event?.pickupTime)}
                orderRef={orderRef}
                listCheckedOrder={listCheckedOrder}
                orderNo={orderNo}
                isSubmittedPayment={isSubmittedPayment}
                stringRefNumber={stringRefNumber}
                ref={photoRef}
                setPaymentFileUrl={setPaymentFileUrl}
                isQrLoading={missingSelectedOrderRefs.length > 0}
                isPaymentViaHitPay={isPaymentViaHitPay}
              />
            ) : null}

            {showPaymentLater ? <OrderConfirmedAfterClose /> : null}

            {showPending ? <PendingConfirm /> : null}

            {showConfirmedPickup ? (
              <OrderConfirmed
                day={numDayFromNow(convertToCurrentGMT(event.pickupTime))}
                isSubmitted={status === HOST_ORDER_SUBMITTED_VERIFIED}
              />
            ) : null}

            {showConfirmedCollect ? (
              <CollectionConfirm
                isSubmittedCollect={isSubmittedCollect}
                day={moment
                  .unix(convertTimestampToCurrentGMT(event?.pickupTimestamp))
                  .utcOffset(GMT_0)
                  .format(SHORT_DATE)}
                host={event?.createdUserName}
                handleConfirmCollection={handleConfirmCollection}
              />
            ) : null}

            {showRefundConfirm ? (
              <RefundConfirm
                isSubmittedRefund={isSubmittedRefund}
                handleConfirmRefund={handleBuyerConfirmRefund}
              />
            ) : null}

            {showRefunded ? <Refunded /> : null}

            {showCollected ? <Collected /> : null}
            {!showPending && showSubmitted ? <Submitted status={submittedStatus} /> : null}

            {showCancel ? <Cancel /> : null}
          </div>
        ) : null}
      </section>
      <AmendDeliveryAddressModal
        isOpen={isAmendAddressModalOpen}
        toggle={() => setIsAmendAddressModalOpen(false)}
        orderRef={orderRef}
        currentBookingAddress={currentBookingAddress}
        onAddressUpdated={handleBookingAddressUpdated}
        deliveryDateParent={currentDeliveryDate || orderDetail?.find((item) => item.ref === orderRef)?.deliveryDate}
      />
    </>
  )
}
export default PurchaseDetail
